// Cooperative fixed-timestep scheduler (~30 Hz). The original game is written as
// blocking loops with EndCycle()/VideoUpdate(); we reproduce that structure with
// async/await: `nextTick()` yields until the next 30 Hz frame boundary, letting
// sequence code (title fades, boss intros, endings) read almost verbatim.

import { FRAME_MS } from './constants';

let resolvers: Array<() => void> = [];
let last = 0;
let acc = 0;

export function initLoop(): void {
  last = performance.now();
  const step = (now: number) => {
    let delta = now - last;
    last = now;
    if (delta > 250) delta = 250; // clamp after tab switch / hitches
    acc += delta;
    while (acc >= FRAME_MS) {
      acc -= FRAME_MS;
      flush();
    }
    requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
}

function flush(): void {
  if (resolvers.length === 0) return;
  const r = resolvers;
  resolvers = [];
  for (const fn of r) fn();
}

// Resolve at the next frame boundary.
export function nextTick(): Promise<void> {
  return new Promise((resolve) => {
    resolvers.push(resolve);
  });
}
